import { IconProps } from '../types';

function NdaSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        fillRule="evenodd"
        d="M15.79,7.55l.53,3.56h-1.11l.54-3.56h.04ZM10.53,7.41c-.16-.09-.35-.13-.59-.13h-.45v5.34h.45c.24,0,.44-.04.6-.13s.28-.21.35-.38c.08-.17.12-.36.12-.59v-3.15c0-.24-.04-.43-.12-.59s-.2-.28-.36-.37ZM20,6v8c0,1.66-1.34,3-3,3H3c-1.66,0-3-1.34-3-3V6c0-1.66,1.34-3,3-3h14c1.66,0,3,1.34,3,3ZM6.66,5.96h-1.36l.02,5.23h-.02l-1.79-5.23h-1.53v7.98h1.35v-5.23s0,0,0,0l1.79,5.23h1.54v-7.98ZM12.58,8.34c0-.51-.09-.94-.26-1.3s-.44-.63-.79-.81c-.35-.18-.8-.28-1.33-.28h-2.26v7.98h2.26c.54,0,.99-.09,1.34-.27.35-.18.62-.45.79-.8s.26-.8.26-1.33v-3.19ZM18.33,13.94l-1.56-7.98h-2.02l-1.56,7.98h1.58l.25-1.64h1.47l.24,1.64h1.59Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default NdaSolidIcon;
